import React, { Component } from 'react';

import ComplexPartner from './complexPartner';

const steps = {
	initial: 0,
	set_api_data: 0,
	set_customer_id: 0,
	set_config: 1,
	set_config_entities: 1,
	set_auth_link: 1,
	set_api_mask: 1,
	success: 1,
};

const LyonEats = props => {
	return (
		<ComplexPartner
			key_={props.key_}
			index={props.index}
			setBlurBackground={props.setBlurBackground}
			steps={steps}
		/>
	);
};

export default LyonEats;
